import React from 'react';
import Statistics from '../App/containers/statistics/statistics';
import Admin from '../App/containers/admin/admin';
import Coaches from '../App/containers/coaches/coaches';
import Ranking from '../App/containers/ranking/ranking';

import { Switch, Route, Redirect } from 'react-router-dom';

export default () => (
  <Switch>
    <Route path='/dashboard/statistics' component={Statistics} />
    <Route path='/dashboard/coaches' component={Coaches} />
    <Route path='/dashboard/ranking' component={Ranking} />
    {/* <Route path='/dashboard/admin' component={Admin} /> */}
    <Redirect from='/dashboard' to='/dashboard/statistics' />
  </Switch>
);


// WEBPACK FOOTER //
// ./src/config/route-content.js